"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var serializeMemberRoles = function (rawRoles) {
    return lodash_1.map(rawRoles && rawRoles.groups, function (_a) {
        var title = _a.title, description = _a.description;
        return ({ name: title, description: description });
    });
};
exports.serializeMemberRoles = serializeMemberRoles;
//# sourceMappingURL=members.js.map